import Swal from 'sweetalert2';

export class ToastService {
   title;

   icon;

   toast;

   constructor() {
      this.toast = Swal.mixin({
         toast: true,
         position: 'top-end',
         showConfirmButton: false,
         timer: 2000,
         timerProgressBar: true,
         didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
            toast.addEventListener('click', Swal.close);
         },
      });
   }

   showAlert() {
      this.toast.fire({
         icon: this.icon,
         title: this.title,
      });
   }

   static success(msg) {
      const vm = new ToastService();
      vm.icon = 'success';
      vm.title = msg;
      vm.showAlert();
   }

   static error(msg) {
      const vm = new ToastService();
      vm.icon = 'error';
      vm.title = msg;
      vm.showAlert();
   }

   static warning(msg) {
      const vm = new ToastService();
      vm.icon = 'warning';
      vm.title = msg;
      vm.showAlert();
   }

   static info(msg) {
      const vm = new ToastService();
      vm.icon = 'info';
      vm.title = msg;
      vm.showAlert();
   }

   static question(msg) {
      const vm = new ToastService();
      vm.icon = 'question';
      vm.title = msg;
      vm.showAlert();
   }
}

export class Alert {
   // customClass is opt-in (defaults to {}, SweetAlert2's own no-op) so
   // every existing caller keeps its current look — only a caller with an
   // unusually long `desc` (see RuleModal's Article 1.5 confirmation) needs
   // to pass its own scoped class to shrink that dialog specifically,
   // rather than affecting every confirm() popup app-wide.
   static confirm(title = '', desc = '', customClass = {}) {
      return new Promise((resolve) => {
         Swal.fire({
            title: title,
            text: desc,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonColor: '#bcbaba',
            confirmButtonColor: '#518FED',
            icon: 'question',
            customClass,
         }).then((result) => {
            if (result.isConfirmed) {
               return resolve(true);
            }
            return resolve(false);
         });
      });
   }
   // customClass mirrors confirm()'s same opt-in param (see its comment).
   // SweetAlert2's `text` option is silently dropped whenever `html` is
   // also set (html always wins) — since this dialog already needs `html`
   // for the link button, `desc` is rendered as part of that same html
   // string instead, with customClass.htmlContainer (if given) applied
   // directly to its wrapping <p> so callers can still opt into a
   // smaller/secondary text style without a global typography change.
   static confirmWithBtn(title = '', desc = '', url = '', showConfirmButton = true, customClass = {}) {
      return new Promise((resolve) => {
         const descClass = customClass.htmlContainer || '';
         Swal.fire({
            title: title,
            showCancelButton: true,
            showConfirmButton: showConfirmButton,
            confirmButtonText: 'Yes',
            cancelButtonColor: '#bcbaba',
            confirmButtonColor: '#518FED',
            icon: 'question',
            customClass: {
               ...(customClass.popup ? { popup: customClass.popup } : {}),
               ...(customClass.title ? { title: customClass.title } : {}),
            },
            html: `${desc ? `<p class="${descClass}">${desc}</p>` : ''}<a href="${url}" target="_blank" class="swal2-button">View Shift Scheduler</a>`,
            didRender: () => {
               const button = document.querySelector('.swal2-button');
               button.style.backgroundColor = '#518FED';
               button.style.color = 'white';
               button.style.padding = '10px';
               button.style.borderRadius = '5px';
               button.style.textDecoration = 'none';
               button.style.display = 'inline-block';
            }
         }).then((result) => {
            if (result.isConfirmed) {
               return resolve(true);
            }
            return resolve(false);
         });
      });
   }
   static success(title = '', desc = '') {
      // return Swal.fire(title,desc,"success")
      return new Promise((resolve) => {
         Swal.fire({
            title: title,
            text: desc,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            confirmButtonColor: '#03A415',
            icon: 'success',
         }).then((result) => {
            if (result.isConfirmed) {
               return resolve(true);
            }
            return resolve(false);
         });
      });
   }

   static error(title = '', desc = '') {
      return Swal.fire(title, desc, 'error');
   }

   static warning(title = '', desc = '') {
      return Swal.fire(title, desc, 'warning');
   }

   static question(title = '', desc = '') {
      return Swal.fire(title, desc, 'error');
   }
}
